import { z } from 'zod';
/**
 * Portable club export/import format descriptors.
 *
 * The full pipeline is Phase 6, but the version constants and the manifest
 * schema are fixed now so every module written from Phase 1 onward targets a
 * stable contract (master prompt §50–§58).
 */
/** Bump when the on-disk archive layout changes in a breaking way. */
export const EXPORT_FORMAT_VERSION = 1;
/** Bump when the logical shape of any exported record changes. */
export const EXPORT_SCHEMA_VERSION = 1;
export const exportManifest = z.object({
    export_version: z.number().int().positive(),
    schema_version: z.number().int().positive(),
    app_version: z.string(),
    exported_at: z.string().datetime(),
    organization_uuid: z.string().uuid(),
    organization_name: z.string(),
    modules: z.array(z.string()),
    statistics: z.record(z.number().int().nonnegative()),
    checksums: z.record(z.string()),
});
//# sourceMappingURL=export-format.js.map